import axios from "axios";

const API = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}`,
});

async function readHistoryEntryService(
  token,
  audioIds,
  compAudioIds,
  type,
  subtopic,
  category,
  subtopic_data
) {
  const response = await API.post("/read-history", {
    token: token,
    audio_ids: audioIds,
    comp_audio_ids: compAudioIds,
    type: type,
    // "type": "update or check",
    subtopic: subtopic,
    category: category,
    subtopic_data: subtopic_data,
  });
  return response.data;
}

export { readHistoryEntryService };
